import { createExternalInterface, getOpenerExternalInterface } from './external-interface-factory'

export const initializeExternalInterface = async () => {
  globalThis.shellExternalInterface = getOpenerExternalInterface() ?? createExternalInterface()
}
